



















import Vue from 'vue'
import Battlefield from '@/components/Battlefield.vue'
import GameInfo from '@/components/GameInfo.vue'
import Preparation from '@/components/Preparation.vue'
import Shop from '@/components/Shop.vue'

export default Vue.extend({
  name: 'ChessBoard',
  components: {Battlefield, GameInfo, Preparation, Shop},
})
